module.exports = __webpack_public_path__ + "img/Uneven Thickness.97971a6e.png";